import { render, staticRenderFns } from "./DisclosureButton.vue?vue&type=template&id=749b9ca9"
import script from "./DisclosureButton.vue?vue&type=script&lang=js"
export * from "./DisclosureButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports